import DividerWithText from '../../../../../components/DividerWithText';
import React from 'react';
import RowResumeText from '../../../../../components/RowResumeText';
import { useTranslation } from 'react-i18next';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import { MODEL_MEASUREMENT_UNIT } from '../Model/Models';
import {getValueByKey} from "../../../../../Apis/functions";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IngredientSummary = ({ item, photoPicker }) => {

    const { t } = useTranslation();

    return (<div className='row'>
        <DividerWithText title={t('photography')} />
        <PhotoPickerSummary
            photoPicker={photoPicker}
            classWith={'w-400px'}
        />
        <DividerWithText title={t('details')} />
        <div className='mb-2 d-flex flex-column align-items-center gap-4 w-100'>
            <div className='row'>
                <div className='col-6'>
                    <RowResumeText title={t('name')} value={item?.name} />
                </div>
                <div className='col-6'>
                    <RowResumeText title={t('item_code')} value={item?.code} />
                </div>
                <div className='col-12'>
                    <RowResumeText title={t('unit_of_measure')} value={t(getValueByKey(item.measurementUnitId, 'trans', MODEL_MEASUREMENT_UNIT))}  />
                </div>
                <div className='col-12'>
                    <RowResumeText title={t('description')} value={item?.description}  />
                </div>
            </div>
        </div>

    </div>)
}

export default IngredientSummary;
